import DashboardContent from 'components/lab/atoms/DashboardContent'
import { ConfirmPrintRunModal } from 'components/lab/billingPatientStatements/ConfirmPrintRunModal'
import { PaperQueueListing } from 'components/lab/billingPatientStatements/PaperQueueListing'
import { PrintRunsListing } from 'components/lab/billingPatientStatements/PrintRunsListing'
import routes from 'components/lab/constants/routes'
import React from 'react'
import { PaperQueueView } from 'store/types'

type PaperStatementsTab = PaperQueueView | 'RUNS'

const TABS: { key: PaperStatementsTab; label: string }[] = [
  { key: PaperQueueView.READY, label: 'Ready to Print' },
  { key: PaperQueueView.HELD, label: 'Held' },
  { key: 'RUNS', label: 'Print Runs' },
]

// Paper statements from the reminder cycle: print, confirm mailed, and the
// history of every run.
export const PaperStatementsPage: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<PaperStatementsTab>(PaperQueueView.READY)
  const [confirmRunId, setConfirmRunId] = React.useState<string | null>(null)

  return (
    <div>
      <DashboardContent
        title={'Ready to Print'}
        icon="fa fa-print"
        content={
          <div className="card card-primary mt-1 p-2">
            <ul className="nav nav-tabs mb-3">
              {TABS.map((tab) => (
                <li className="nav-item" key={tab.key}>
                  <button
                    type="button"
                    className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.key)}>
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
            {activeTab === 'RUNS'
              ? <PrintRunsListing onConfirmRun={setConfirmRunId} />
              : <PaperQueueListing key={activeTab} view={activeTab} onConfirmRun={setConfirmRunId} />}
            <ConfirmPrintRunModal runId={confirmRunId} onHide={() => setConfirmRunId(null)} />
          </div>
        }
        breadcrumb={[
          {
            label: 'Billing',
            to: `${routes.index}`,
          },
        ]}
      />
    </div>
  )
}
